var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMortgage105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.9961 37.9961H60.9961V54.9961H43.9961V37.9961ZM44.9961 38.9961V53.9961H59.9961V38.9961H44.9961ZM41.9961 69.9961H62.9961V93.9961H85.9961V51.9961H86.9961V94.9961H17.9961V51.9961H18.9961V93.9961H41.9961V69.9961ZM42.9961 93.9961H61.9961V70.9961H42.9961V93.9961Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.8129 46.1091L52.4963 9.8501L22.9961 33.9866V18.4961H21.9961V34.8048L8.17969 46.1091L8.81293 46.8831L52.4963 11.1422L96.1797 46.8831L96.8129 46.1091Z",
  fill: "var(--icon-decorative-coral)"
})));
export default SvgMortgage105;